import {get} from "lodash"
import BaseService from "./Base"
import {
    GicIntegrationRunListRequest,
    GicIntegrationRunListResponse,
    GicStudentProfileSyncListRequest,
    GicStudentProfileSyncListResponse
} from "types/integrations/gic"

class GicIntegrationService extends BaseService {
    async listStudentProfileSyncs(
        params: GicStudentProfileSyncListRequest
    ): Promise<GicStudentProfileSyncListResponse> {
        const response = await this.post("/v1/integrations/gic/student-profile-syncs/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async queueManualStudentProfileSync(profileId: number): Promise<void> {
        await this.post("/v1/integrations/gic/student-profile-syncs/manual", {profileId})
    }

    async listIntegrationRuns(params: GicIntegrationRunListRequest): Promise<GicIntegrationRunListResponse> {
        const response = await this.post("/v1/integrations/gic/runs/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }
}

export default GicIntegrationService
